<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  .content{
    margin: 0 auto;
    font-size: 20px;
  }
  #app{background-image: radial-gradient(#fafffe, #ffffff);}
  .content P{text-align: justify;}
  @media screen and (max-width: 768px) {
    .content p,.content ul li{font-size: 14px !important;}
    .content ul li{padding-bottom: 10px !important;}
    ul{list-style-type: none;padding: 0 !important;}
    .content{padding:0px 10px !important;}
  }
</style>



// WEBPACK FOOTER //
// src/App.vue